import { SeriesNameType } from '../../core';

/**
 * Types for metric labels, used in series_name_format implementation
 */
export type SeriesLabels = Record<string, string>;

export type SeriesName =
  | {
      type: SeriesNameType.Labels;
      name_pattern?: string | undefined;
    }
  | {
      type: SeriesNameType.Regex;
      regex?: string | undefined;
      name_pattern?: string | undefined;
    }
  | undefined;

/*
 * Formatter used for series name display in legends and tooltips.
 * Regex replaces label {{ name }} with resolved label value.
 * If no resolved value, return empty string instead of the token inside double curly braces.
 */
export function renameSeriesWithLabels(inputFormat: string, seriesLabels: SeriesLabels): string {
  const resolveLabelsRegex = /\{\{\s*(.+?)\s*\}\}/g;
  return inputFormat.replace(resolveLabelsRegex, (_match, token) => {
    const resolvedValue = seriesLabels[token] ?? '';
    return resolvedValue;
  });
}

export function renameSeriesWithRegex(currentName: string, series_name: SeriesName) {
  if (!series_name || series_name.type !== SeriesNameType.Regex) {
    return currentName;
  }

  const { regex, name_pattern } = series_name;
  if (regex === undefined || regex === null || name_pattern === undefined || name_pattern === null) {
    return currentName;
  }

  return currentName.replace(new RegExp(regex), name_pattern);
}
